import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { thumbImg, pad2, cleanTribe } from '@/lib/databank';

export const SpecimenCard = ({ plant, index }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            initial={reduce ? false : { opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-5%' }}
            transition={{ duration: 0.7, delay: (index % 8) * 0.05, ease: [0.16, 1, 0.3, 1] }}
        >
            <Link
                to={`/plant/${plant.plant_no}`}
                data-testid={`specimen-card-${pad2(plant.plant_no)}`}
                className="group block border border-line bg-paper transition-colors duration-300 hover:border-ink"
            >
                <div className="overflow-hidden bg-[#FDFCF6] p-5">
                    <img
                        src={thumbImg(plant)}
                        alt={plant.botanical_name}
                        loading="lazy"
                        className="plate-img mx-auto aspect-[4/5] w-full object-contain transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                </div>
                <div className="border-t border-line p-4">
                    <div className="flex items-baseline justify-between gap-2">
                        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-terra">No. {pad2(plant.plant_no)}</span>
                        <span className="truncate font-mono text-[9px] uppercase tracking-[0.18em] text-mute">{cleanTribe(plant.tribe)}</span>
                    </div>
                    <p className="mt-2 font-serif text-lg italic leading-snug text-ink">{plant.botanical_name}</p>
                    <p className="mt-1 truncate text-xs text-mute">{plant.common_name.replace(/,$/, '')}</p>
                </div>
            </Link>
        </motion.div>
    );
};
